import { useEffect } from "react"

import { APIClientEventType } from "shared/api/http-clients/APIClient"
import { JRAPIClient } from "shared/api/http-clients/JRAPIClient"
import { SchakoAPIClient } from "shared/api/http-clients/SchakoAPIClient"
import { verifyLogin } from "shared/lib/auth/verifyLogin"
import { useEvent } from "shared/lib/useEvent"
import { useWindowFocus } from "shared/lib/useWindowFocus"

import { useLoginStatus } from "widgets/auth-provider/model/login-store"
import { useUserInfo } from "widgets/auth-provider/model/user-info-store"

export function useLoginSession() {
  const isLoggedIn = useLoginStatus()
  const userInfo = useUserInfo()

  const handleVerifyLogin = useEvent(() => {
    verifyLogin()
  })

  const handleAPIClientEvent = useEvent((eventType: APIClientEventType) => {
    if (eventType === APIClientEventType.FAILED_TO_FETCH_TOKEN) {
      handleVerifyLogin()
    }
  })

  useWindowFocus(handleVerifyLogin)

  useEffect(() => {
    const unsubscribeFromSchako =
      SchakoAPIClient.subscribe(handleAPIClientEvent)
    const unsubscribeFromJRAPI = JRAPIClient.subscribe(handleAPIClientEvent)

    verifyLogin()

    return () => {
      unsubscribeFromSchako()
      unsubscribeFromJRAPI()
    }
  }, [])

  return { userInfo, isLoggedIn, isLoading: isLoggedIn === undefined }
}
